import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [ "header", "placeholder" ]

    connect() {
        const header = this.headerTarget;
        const placeholder = this.placeholderTarget;
        const stickyClass = "sticky";

        // Set placeholder height to match header height
        const setPlaceholderHeight = () => {
            placeholder.style.height = (`${header.offsetHeight}px`);
            placeholder.classList.add("visually-hidden");
        }

        // Adjust placeholder height on window resize
        window.addEventListener("resize", setPlaceholderHeight);
        setPlaceholderHeight();

        // Add/remove sticky class on scroll
        document.addEventListener("scroll", () => {
            if (window.scrollY > 0) {
                header.classList.add(stickyClass);
                placeholder.classList.remove("visually-hidden");
            } else {
                header.classList.remove(stickyClass);
                placeholder.classList.add("visually-hidden");
            }
        })
    }
}